import { render } from "./pod.vue?vue&type=template&id=5f74bb0a&scoped=true"
import script from "./pod.vue?vue&type=script&lang=js"
export * from "./pod.vue?vue&type=script&lang=js"

import "./pod.vue?vue&type=style&index=0&id=5f74bb0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f74bb0a"]])

export default __exports__